/**
 * Extracts and normalizes a path suffix from the router query parameter.
 * Ensures the result is either empty or starts with a leading slash.
 */
export function getPathSuffix(path) {
  const decodedPath = typeof path === 'string' ? decodeURIComponent(path) : '';
  return decodedPath && !decodedPath.startsWith('/') ? `/${decodedPath}` : decodedPath;
}
